import API from "@/utils/Api";
import { get } from "@/context/context";
import {AxiosResponse} from "axios";
import {RequestConfig} from "@/models/RequestConfig";
import {PaginatedResponse} from "@/models/PaginatedResponse";
import {Paginated} from "@/models/Paginated";
import {Type, TypeResponse} from "@/models/Type/Type";
import {ExerciseRepository} from "@/repositories/ExerciseRepository";
import {ExerciseListRequest} from "@/models/Exercise/ExerciseListRequest";
import {Exercise, ExerciseResponse} from "@/models/Exercise/Exercise";

export class ExerciseApi implements ExerciseRepository {

    private api: API = get('api');

    public async getClassList(request?: ExerciseListRequest): Promise<Paginated<Exercise>> {
        const response: AxiosResponse<PaginatedResponse<ExerciseResponse>> =
            await this.api.get('/uploader/wix/exercise/get-exercises-by-type', {...(request || {})});

        return Paginated.map(response.data, Type);
    }

}
